import { IFactService } from "../../service/evaluation/FactService";

export default class GetFactsInteractor {
  private factService: IFactService;

  constructor(factService) {
    this.factService = factService;
  }

  async execute() {
    return this.factService.getFacts();
  }
}
